export const segments: any = [
  {
    id: 'item-details',
    segment: 'details',
    name: 'item-details', // for the segment nav anchor
    title: 'Details',
    circleIcon: false,
    active: false,
  },
  {
    id: 'descriptions',
    segment: 'descriptions',
    title: 'Description',
    circleIcon: false,
    active: false,
  },
  {
    id: 'marketing',
    segment: 'marketing',
    title: 'Marketing',
    circleIcon: false,
    active: false,
  },
    {
    id: 'fitments',
    segment: 'fitments',
    title: 'Fitments',
    circleIcon: false,
    active: false,
  },
  {
    id: 'prices',
    segment: 'pricing',
    title: 'Pricing',
    circleIcon: false,
    active: false,
  },
  {
    id: 'assets',
    segment: 'digitalAssets',
    title: 'Digital assets',
    circleIcon: false,
    active: false,
  },
  {
    id: 'attributes',
    segment: 'attributes',
    title: 'Attributes',
    circleIcon: false,
    active: false,
  },
  {
    id: 'packages',
    segment: 'packages',
    name: 'packages',
    title: 'Packaging',
    circleIcon: false,
    active: false,
  },
  {
    id: 'kits',
    segment: 'kits',
    title: 'Kits',
    circleIcon: false,
    active: false,
  },
  {
    id: 'interchanges',
    segment: 'interchanges',
    title: 'Interchange',
    circleIcon: false,
    active: false,
  },
  {
    id: 'customFields',
    segment: 'customFields',
    title: 'Custom fields',
    circleIcon: false,
    active: false,
  },
];
